import alt from 'components/Dispatcher';

class TeamMoveDialogActions {
  constructor() {
    this.generateActions('stageDepartmentToReceive', 'openForTeam');
  }
}

export default alt.createActions(TeamMoveDialogActions);
